import React from "react";
import { MapPin } from "lucide-react";

interface Installation {
  latitude: number;
  longitude: number;
  accuracy_category: string | null;
  location_accuracy: number | null;
  captured_at: string | null;
}

interface LocationCardProps {
  installation: Installation;
}

const formatDate = (isoString: string | null) => {
  if (!isoString) return null;
  return new Date(isoString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const LocationCard: React.FC<LocationCardProps> = ({ installation }) => {
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${installation.latitude},${installation.longitude}`;

  const accuracyLabel = installation.location_accuracy
    ? `±${Math.round(installation.location_accuracy)}m accuracy`
    : installation.accuracy_category
    ? `${installation.accuracy_category} accuracy`
    : null;

  return (
    <div className="bg-card rounded-xl shadow-sm border overflow-hidden transition-all duration-300 hover:shadow-md">
      <div className="border-b bg-muted/30 px-6 py-4 flex items-center">
        <MapPin className="h-5 w-5 text-primary mr-2" />
        <h3 className="font-medium text-foreground">Headstone Location</h3>
      </div>
      <div className="p-6 space-y-4">
        <a
          href={directionsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 w-full bg-primary text-primary-foreground rounded-lg px-4 py-4 text-base font-medium hover:bg-primary/90 transition-colors min-h-[48px]"
        >
          <MapPin className="h-5 w-5" />
          Get Directions
        </a>
        {(accuracyLabel || installation.captured_at) && (
          <p className="text-sm text-muted-foreground text-center">
            {[accuracyLabel, installation.captured_at ? `Captured ${formatDate(installation.captured_at)}` : null]
              .filter(Boolean)
              .join(" · ")}
          </p>
        )}
      </div>
    </div>
  );
};
